module.exports = __webpack_public_path__ + "static/akinajo-12e9e9ad89a48d7bc80b523b4b5c3b58.png";